export const charactersRemaining = (str, maxLength) => {
    if (!str) {
        return maxLength;
    }

    return maxLength - str.length;
};
